module.exports = __webpack_public_path__ + "img/img_brand28.7de77303.jpg";